export default __webpack_public_path__ + "static/media/Roxanne_Derhodge_AHV_In_Moms_We_Trust.4cbf9fb1.jpg";